import React, { useState } from "react";
import { Button } from "../../atoms/Buttons";
import * as S from "./modal.styles";
import { ImageType } from "../../../interface/transportation";

interface ModalProps {
  children?: React.ReactElement;
  onClose?: () => void;
  title?: string;
  list?: string;
  backGround?: "white" | "stop";
  transportationImages?: ImageType[];
  shadowBack?: boolean;
  titlePosition?: string;
  size?: string;
}

const Modal = ({
  children,
  onClose = () => {},
  title = "",
  backGround = "white",
  shadowBack,
  titlePosition,
  size,
}: ModalProps) => {
  return (
    <>
      {shadowBack ? <></> : <S.ModalBackground />}
      <S.Modal backGround={backGround} size={size}>
        {titlePosition === "center" ? (
          <S.ModalTit className="center">
            <p>{title}</p>
          </S.ModalTit>
        ) : (
          <S.ModalTit>
            <p>{title}</p>
            {onClose && (
              <Button
                type="button"
                color="transparent"
                onClick={onClose}
              ></Button>
            )}
          </S.ModalTit>
        )}
        <S.ModalContent>{children}</S.ModalContent>
      </S.Modal>
    </>
  );
};

export default Modal;
